// extracted by mini-css-extract-plugin
export default {"container":"ModalUpdateProductPricing_container__Zb42C","groupAdd":"ModalUpdateProductPricing_groupAdd__wI6im","table":"ModalUpdateProductPricing_table__Am00I"};